import * as angular from "angular";
import {IController, IRootScopeService} from "angular";
import * as _ from "lodash";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {ServiceAreasService} from "../../../service-areas/services/service-areas-service.service";

export class SiteMarketCtrl implements IController {

  public range: any;
  public customTemplates: any
  public selectedStatus: any;
  public serviceAreas: any;
  public tabs: any;
  public serviceAreasRef: any;
  public routeIds: any;
  public deliveryIds: any;
  public working: any;
  public showIds: any;
  public showTab: any;
  public selectedRoute: any;
  public routeCircles: any;

  constructor(private $serviceArea, private $route, private $stateParams,
              private $rootScope: IRootScopeService, private routeStatuses, private serviceAreasService: ServiceAreasService,
              private mapConstant, private $log, private dateRangeTimeFiltersService: DateRangeTimeFiltersService) {

    this.serviceAreasRef = this.$serviceArea();
  }

  $onInit() {
    this.range = this.dateRangeTimeFiltersService.today();
    this.customTemplates = this.dateRangeTimeFiltersService.getSiteMarketCustomTemplates();
    this.selectedStatus = this.routeStatuses[0];

    this.tabs = ['Routes', 'Deliveries'];
    this.showTab = this.tabs[0];
    this.serviceAreasService.getAll({serviceTypes: 'Pricing'})
      .then((serviceAreas) => {
        this.serviceAreas = serviceAreas;
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Error while getting service areas from server, siteMarket \n' + error)
        }
      });
    this.selectRoute(null);
    this.selectTab(this.$stateParams.tab || this.tabs[0]);
    this.onQuery();
  }

  showMarkers(deliveryIds) {
    this.$rootScope.$broadcast(this.mapConstant.events.siteMarket.removeDeliveryTaskMarkers);
    this.$rootScope.$broadcast(this.mapConstant.events.siteMarket.displayDeliveryTaskMarkers, deliveryIds);
  };


  rangeChanged(range) {
    if (!_.isUndefined(range) && !_.isEqual(range.name, this.range.name)) {
      this.range = range;
      this.onQuery();
    }
  }

  onQuery() {
    const params = {
      status: this.selectedStatus === 'All' ? null : this.selectedStatus,
      from: this.range.dateStart,
      to: this.range.dateEnd
    };

    this.selectRoute(null);
    this.showIds = [];
    this.routeCircles = [];
    this.working = true;

    this.$route().$getAll(params).then(
      (res) => {
        this.deliveryIds = [];
        this.routeIds = [];

        _.map(res, (id) => {
          let value = this.$route(id).$value();

          if (_.get(value, 'serviceIdList.length') === 1) {
            this.deliveryIds.push(id);
          } else {
            this.routeIds.push(id);
          }

        });

        this.working = false;
        this.updateShowList();
      },
      (error) => {
        this.$log.error('Failed to get all routes from server, siteMarket@onQuery \n' + error)
      }
    );
  }

  selectRoute(route) {
    this.$rootScope.$broadcast(this.mapConstant.events.siteMarket.stopAllMarkersBounce);
    this.$rootScope.$broadcast(this.mapConstant.events.siteMarket.removeSuggestedMarkers);
    this.selectedRoute = route;
    //$state.go('.', _.assign({}, $stateParams, {selectedId: route.id}));
    if (!!route) {
      this.routeCircles = [this.selectedRoute];
    } else {
      this.routeCircles = [];
      this.$rootScope.$broadcast(this.mapConstant.events.itinerary.hide);
    }
  }

//                 // **************************
//                 //      Internal methods
//                 // **************************

  updateShowList() {
    if (this.showTab === 'Routes') {
      this.showIds = this.routeIds;
    } else {
      this.showIds = this.deliveryIds;
    }

    if (!this.selectedRoute) {
      this.routeCircles = [];
    } else {
      this.routeCircles = [this.selectedRoute];
    }
  }

  selectTab(tab) {
    this.showTab = tab;
    this.updateShowList();
  }
}

angular
  .module('bringoz.admin.routes')
  .component('siteMarket', {
    bindings: {},
    template: require('./site-market.html').default,
    controller: SiteMarketCtrl
  });
